var defaultProps = {
  containerProps: {},
  className: '',
  style: {},
  text: '',
  maxCharacters: 0,
  maxWidth: '100%',
  textEllipsis: false,
  textAlignment: 'left',
  wordBreak: true
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
